let getAccessTokenSilently: any = null;

const auth0Security = {
    getAccessTokenSilently: () => getAccessTokenSilently,
    setAccessTokenSilently: (func: Function) => {
        getAccessTokenSilently = func
    }
};

export {auth0Security}